import apiClient from '../Utils/apiClient';

// TODO: implement the API
const getLogs = async (queryString = '') => {
  return apiClient.get(`logs${queryString}`);
};

export { getLogs };
